import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Search, Newspaper, Briefcase, Star, Bell, CreditCard, ChartCandlestick } from "lucide-react";

const LinkedInSidebar = ({ currentPage, setCurrentPage, isLoggedIn }) => {
  const navigate = useNavigate();

  const navigateToPage = (page) => {
    navigate(`/${page === 'feed' ? '' : page}`);
  };

  return (
    <div className="space-y-4">
      {/* Profile Card */}
      {/* <div className="linkedin-card">
        <div className="relative">
          <div className="h-16 bg-gradient-to-r from-blue-500 to-blue-600 rounded-t-lg"></div>
          
          <div className="absolute -bottom-8 left-1/2 transform -translate-x-1/2">
            <div className="w-16 h-16 bg-white rounded-full p-1">
              <img 
                src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face"
                alt="Profile"
                className="w-full h-full rounded-full object-cover"
              />
            </div>
          </div>
        </div>
        
        <div className="pt-10 pb-4 px-4 text-center">
          <h3 className="font-semibold text-gray-900 text-lg">Sam Lanson</h3>
          <p className="text-sm text-gray-600 mb-4">Web Developer at StackBros</p>
          <p className="text-sm text-gray-700 mb-4">
            I'd love to change the world, but they won't give me the source code.
          </p>
          
          <div className="flex justify-around border-t border-gray-200 pt-4">
            <div className="text-center">
              <div className="text-xl font-bold text-gray-900">256</div>
              <div className="text-xs text-gray-600">Posts</div>
            </div>
            <div className="text-center">
              <div className="text-xl font-bold text-gray-900">2.5K</div>
              <div className="text-xs text-gray-600">Followers</div>
            </div>
            <div className="text-center">
              <div className="text-xl font-bold text-gray-900">365</div>
              <div className="text-xs text-gray-600">Following</div>
            </div>
          </div>
        </div>
        
      </div> */}

      {/* Navigation Card */}
      <div className="linkedin-card">
        <div className="py-2">
          <nav className="space-y-1">
            <button
              onClick={() => setCurrentPage('')}
              className={`linkedin-sidebar-link ${['', 'feed'].includes(currentPage) ? 'active' : ''}`}
            >
              <Newspaper className="w-5 h-5 mr-3" />
              Feed
            </button>
            <button
              onClick={() => setCurrentPage('search')}
              className={`linkedin-sidebar-link ${currentPage === 'search' ? 'active' : ''}`}
            >
              <Search className="w-5 h-5 mr-3" />
              Search
            </button>
            <button
              onClick={() => setCurrentPage('ratings')}
              className={`linkedin-sidebar-link ${currentPage === 'ratings' ? 'active' : ''}`}
            >
              <Star className="w-5 h-5 mr-3" />
              Rankings
            </button>
            <button
              onClick={() => setCurrentPage('notifications')}
              className={`linkedin-sidebar-link ${currentPage === 'notifications' ? 'active' : ''}`}
            >
              <Bell className="w-5 h-5 mr-3" />
              Notifications
            </button>
            <button
              onClick={() => setCurrentPage('over-undervalued-companies')}
              className={`linkedin-sidebar-link ${currentPage === 'over-undervalued-companies' ? 'active' : ''}`}
            >
              <ChartCandlestick className="w-5 h-5 mr-3" />
              Undervalued - AI Analysis
            </button>
            <button
              onClick={() => setCurrentPage('subscriptions')}
              className={`linkedin-sidebar-link ${currentPage === 'subscriptions' ? 'active' : ''}`}
            >
              <CreditCard className="w-5 h-5 mr-3" />
              Subscribe to Pro
            </button>
            {/* <button
              onClick={() => setCurrentPage('portfolio')}
              className={`linkedin-sidebar-link ${currentPage === 'portfolio' ? 'active' : ''}`}
            >
              <Briefcase className="w-5 h-5 mr-3" />
              Portfolio
            </button> */}
          </nav>
        </div>
      </div>

      {/* Settings Card */}
      {/* <div className="linkedin-card">
        <div className="py-2">
          <button className="linkedin-sidebar-link">
            <svg className="w-5 h-5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
            Settings
          </button>
        </div>
      </div> */}

    </div>
  );
};

export default LinkedInSidebar;